import React from 'react'
import FormTranslationComponent from './FormTranslationComponent'

const FormNewTranslation = () => {
  return <FormTranslationComponent isNew />
}

export default FormNewTranslation
